export enum PaymentErrorMessage {
  systemErrorTryAgainLater = 'checkoutReview.error.systemErrorTryAgainLater.message',
  issueWithProduct = 'checkoutReview.error.issueWithProduct.message',
  paymentRejected = 'checkoutReview.error.paymentRejected.message',
  stripeProcessing = 'checkoutReview.error.stripeProcessing.message',
  somethingWrong = 'configurator.error.somethingWrong',
  ccLimitExceeded = 'checkoutReview.error.ccLimitExceeded.message',
  threeDsFailure = 'checkoutReview.error.threeDsFailure.message',
}
